import { lazy } from "react";

import CareIcon from "@/CAREUI/icons/CareIcon";

import { PluginManifest } from "@/pluginTypes";

const AbdmFacilityPage = lazy(() => import("./AbdmFacilityPage"));

// Wording: public/locale/<lang>.json, loaded by CARE as this plugin's i18n
// namespace (served at /local-plugins/myhis-abha/locale/).
const manifest: PluginManifest = {
  plugin: "myhis-abha",
  routes: {
    // The facility's ABDM desk: scan-and-share inbox, staff HPR, sharing log.
    "/facility/:facilityId/abdm": ({ facilityId }) => (
      <AbdmFacilityPage facilityId={facilityId} />
    ),
  },
  components: {
    PatientRegistrationForm: lazy(() => import("./AbhaRegistrationPanel")),
    PatientDetailsTabDemographyGeneralInfo: lazy(
      () => import("./AbhaPatientCard"),
    ),
    PatientSearchActions: lazy(() => import("./AbdmDeskButton")),
    FacilityHomeActions: lazy(() => import("./AbdmDeskButton")),
    UserProfileSections: lazy(() => import("./HprCard")),
  },
  encounterTabs: {
    // This visit on ABHA, and records from other facilities.
    abha: lazy(() => import("./EncounterAbhaTab")),
  },
  // The ABHA desk in the facility's left navigation (url is prefixed with
  // /facility/<id>/ by CARE; the label is static, read before the plugin's
  // locale loads).
  navItems: [
    {
      name: "ABHA shares",
      url: "abdm",
      icon: <CareIcon icon="l-qrcode-scan" />,
    },
  ],
};

export default manifest;
